import React from 'react';
import './Header.css';

export default function Header() {
  return (
    <header className="header">
      <div className="header-left">
        <FlameIcon />
        <h1 className="header-title">Wildfire Tracker</h1>
        <span className="header-live">LIVE</span>
      </div>
      <div className="header-right">
        <span className="header-source">NASA EONET API</span>
        <a
          className="header-link"
          href="https://eonet.gsfc.nasa.gov/"
          target="_blank"
          rel="noreferrer"
        >
          eonet.gsfc.nasa.gov ↗
        </a>
      </div>
    </header>
  );
}

function FlameIcon() {
  return (
    <svg className="flame-icon" viewBox="0 0 20 24" fill="none" aria-hidden="true">
      <path
        d="M10 2C10 2 14 7 14 11C14 13.8 12.2 15 10 15C7.8 15 6 13.8 6 11C6 9 7 7.5 7 7.5C7 7.5 6 10 8 11.5C8 9 9 6.5 10 5C10 5 11.5 7 12 9.5C13 8.5 13.5 7 13.5 5.5C15 7.5 16 10 16 13C16 17.4 13.3 21 10 21C6.7 21 4 17.4 4 13C4 8.5 7 4 10 2Z"
        fill="#D85A30"
      />
      <path
        d="M10 13C10 13 11.5 11.5 11.5 10C11.5 11 10.8 12 10 13C9.2 12 8.5 11 8.5 10C8.5 11.5 10 13 10 13Z"
        fill="#EF9F27"
      />
    </svg>
  );
}
